import { render } from "./BalModal.vue?vue&type=template&id=44e2e8d9&scoped=true"
import script from "./BalModal.vue?vue&type=script&lang=ts"
export * from "./BalModal.vue?vue&type=script&lang=ts"

import "./BalModal.vue?vue&type=style&index=0&id=44e2e8d9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-44e2e8d9"

export default script